import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Image, Segment } from 'semantic-ui-react'

import back from '../../assets/images/angle-fuchsia.png'
import Modules from '../common/modules'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { actions as participants } from '../../store/actions/participants'

// Import Highcharts
import Highcharts from "highcharts/highstock";
import Chart from "../highchart/Chart.jsx";

class ParticipantWearingTime extends Component {
    constructor (props) {
        super(props)
        this.state = {
            chart_data: []
        }
        autoBind(this)
    }

    componentDidMount () {
        // Fetch the exercises.
        this.setState({ chart_data: [] })
        this.fetchSignalTimeMetric(this.props.module)
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.module !== nextProps.module) {
            // Fetch the exercises.
            this.setState({ chart_data: [] })
            this.fetchSignalTimeMetric(nextProps.module)
        }
    }

    round_data (data) {
        data.forEach((element) => {
            element.y = Math.round(element.y);
        });
        
        return data;
    }

    setOptions (){
        var data = this.round_data(this.state.chart_data)
        return {
            title: {
              text: ''
            },
            series: [
              {
                name: "Wearing time",
                data: data
              }
            ],
            xAxis: [
              {
                type: 'datetime',
                labels: {
                    format: '{value:%d/%m/%y}'
                }
              }
            ],
            yAxis: [
                {
                  title: {
                    text: 'Wearing time hours'
                  }
                }
              ]
          }
    }

    // Fetch signal time metric
    fetchSignalTimeMetric (module) {
        if (!module) {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Fetch signal time metric.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/signaltime/${module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched signal time metric.')
                this.setState({
                    chart_data: response.data.chart_data
                })
            })
            .catch((error) => {
                // Failed to count journals.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch signal time metric.', error)
                // Hide the error.
                this.setState({ chart_data: [] })
            })
    }

    // Changes to the module with the given ID.
    changeModule (module) {
        this.props.changeLocation({ module })
    }

    render () {
        return (
            <Container className='participant-journals'>
                <Segment
                    className='navigation-item'
                    onClick={(_e) => { this.props.onChangeSubsection(undefined) }}
                >
                    <Image src={back}/>
                    {tr('SENSOR_WEARING_TIME')}
                </Segment>
                <Modules
                    language={this.props.language}
                    timezone={this.props.timezone}
                    onChangeModule={(module) => { this.changeModule(module) }}
                />
                <Chart options={this.setOptions()} highcharts={Highcharts} />
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        module: state.participants.location.module,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        changeLocation: _participants.changeLocation
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantWearingTime))



// WEBPACK FOOTER //
// ./src/components/participant-wearing-time/index.js